import React, {useEffect, useState} from 'react';
import {DeleteOutlined, PlusOutlined, SaveOutlined} from "@ant-design/icons";
import $ from "jquery";
import axios from "axios";
import {header} from "../../../../../../../components/api/Header";
import { getEnv } from "../../../../../../../lib/env";

const novegmonth = ["Oktyabr", "Noyabr", "Dekabr", "Yanvar", "Fevral", "Mart"]
const vegmonth = ["Aprel", "May", "Iyun", "Iyul", "Avgust", "Sentyabr"]

function Ste() {
    const season = localStorage.getItem("sfr-hm-season")
    const [ste, setSte] = useState(localStorage.getItem("sfr-hm-ste") ? JSON.parse(localStorage.getItem("sfr-hm-ste")) : [])
    const manbalar = localStorage.getItem("sfr-hm-manbalar") ? JSON.parse(localStorage.getItem("sfr-hm-manbalar")) : []
    const [forDelete, setForDelete] = useState()
    const [yonalishlar, setYonalishlar] = useState([])
    const [saved, setSaved] = useState(true)
    useEffect(() => {
        const fetchData = async () => {
            const res = await axios.get(getEnv('REACT_APP_BASE_URL') + "/v1/district/sfrmain/yonalishlar", header())
                .catch(err => {
                    console.log("Xato", err)
                })
            if (res) {
                setYonalishlar(res.data)
            }
        }
        fetchData()

    }, [])
    const [hasEnergetika, setHasEnergetika] = useState(ste.filter(st => st.yonalish == 5).length > 0 ? true : false)
    let months = []
    if (season == 'veg') {
        months = vegmonth
    } else {
        months = novegmonth
    }
    const addHandler = () => {
        let s = [...ste]
        let max_id = 0
        for (var i = 0; i < s.length; i++) {
            if (s[i].id > max_id) {
                max_id = s[i].id
            }
        }
        let nste = {
            id: max_id + 1,
            manba: '',
            name: '',
            yonalish: '',
            d1: 0,
            d2: 0,
            d3: 0,
            d4: 0,
            d5: 0,
            d6: 0,
            d7: 0,
            d8: 0,
            d9: 0,
            d10: 0,
            d11: 0,
            d12: 0,
            d13: 0,
            d14: 0,
            d15: 0,
            d16: 0,
            d17: 0,
            d18: 0,
            limit: {daryo: '', yer: '', zovur: ''},
            q: 0
        }
        s.push(nste)
        setSte(s)
        setSaved(false)
    }
    const checkSte = (e, i) => {
        if (e) {
            $("input[type=checkbox]").each(function () {
                if ($(this)[0].className != 'checkbox' + i) {
                    $(this)[0].checked = false
                }
            })
            setForDelete(i)
        } else {
            setForDelete()
        }
    }
    const setSteHandler = (v, i, c) => {
        if(c!='name'){
            v = parseFloat(v)
        }
        let s = [...ste]
        s[i][c] = v
        setSte(s)
        setSaved(false)
        setHasEnergetika(s.filter(st => st.yonalish == 5).length > 0 ? true : false)
    }
    const deleteHandler = () => {
        let s = ste.filter((s, i) => s.id != forDelete)
        setSte(s)
        $("input[type=checkbox]").each(function () {
            $(this)[0].checked = false
        })
        setSaved(false)
    }
    const saveHandler = () => {
        let err = 0
        let q = 0
        if (ste.length) {
            ste.map((s, i) => {
                if (s.manba == '') {
                    err = 1
                    q = i
                    return false
                } else if (s.name == '') {
                    q = i
                    err = 2
                    return false
                } else if (s.yonalish == '') {
                    q = i
                    err = 3
                    return false
                }
            })
        }
        if (err == 1) {
            alert((q + 1) + "- qatorda manba tanlanmagan. Iltimos manbalardan birini tanlang yoki " + (q + 1) + "- qatordagi istemolchini o'chiring!")
        } else if (err == 2) {
            alert((q + 1) + "- qatorda istemolchi nomi kiritilmagan. Iltimos istemolchiga nom kiriting yoki " + (q + 1) + "- qatordagi istemolchini o'chiring!")
        } else if (err == 3) {
            alert((q + 1) + "- qatorda yo'nalish tanlanmagan. Iltimos yo'nalishlardan birini tanlang yoki " + (q + 1) + "- qatordagi istemolchini o'chiring!")
        } else {
            localStorage.setItem('sfr-hm-ste', JSON.stringify(ste))
            setSaved(true)
            window.location = "/sfr/gidromodul/new/insert/maydon"
        }
    }
    console.log(forDelete)
    console.log(ste)
    return (
        <div className="row">
            <div className="col-12 mb-2">
                <h3 className="text-center">Sanoat va texnik extiyojlar (l/s)</h3>
            </div>
            <div className="col-12">
                <div className="flextable">
                    <table className="table table-bordered table-striped">
                        <thead>
                        <tr>
                            <th rowSpan={2} className="text-center vertical-middle">o</th>
                            <th rowSpan={2} className="text-center vertical-middle">T/r</th>
                            <th rowSpan={2} className="text-center vertical-middle">Suv manbalari</th>
                            <th rowSpan={2} className="text-center vertical-middle">Suv istemolchilari / foydalanuvchilar</th>
                            <th rowSpan={2} className="text-center vertical-middle">Yo'nalishlar</th>
                            <th colSpan={3} className="text-center vertical-middle">{months[0]}</th>
                            <th colSpan={3} className="text-center vertical-middle">{months[1]}</th>
                            <th colSpan={3} className="text-center vertical-middle">{months[2]}</th>
                            <th colSpan={3} className="text-center vertical-middle">{months[3]}</th>
                            <th colSpan={3} className="text-center vertical-middle">{months[4]}</th>
                            <th colSpan={3} className="text-center vertical-middle">{months[5]}</th>
                            {
                                hasEnergetika ?
                                    <th colSpan={3} className="text-center">Qayt may digan</th>
                                    : null
                            }
                        </tr>
                        <tr>
                            <th className="text-center">1</th>
                            <th className="text-center">2</th>
                            <th className="text-center">3</th>
                            <th className="text-center">1</th>
                            <th className="text-center">2</th>
                            <th className="text-center">3</th>
                            <th className="text-center">1</th>
                            <th className="text-center">2</th>
                            <th className="text-center">3</th>
                            <th className="text-center">1</th>
                            <th className="text-center">2</th>
                            <th className="text-center">3</th>
                            <th className="text-center">1</th>
                            <th className="text-center">2</th>
                            <th className="text-center">3</th>
                            <th className="text-center">1</th>
                            <th className="text-center">2</th>
                            <th className="text-center">3</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            ste.length ?
                                ste.map((s, i) => {
                                    return <tr key={i}>
                                        <td><input type="checkbox" className={'checkbox' + s.id}
                                                   onChange={e => checkSte(e.target.checked, s.id)}/></td>
                                        <td>{i + 1}</td>
                                        <td className="inptd">
                                            <select className="inputable" value={s.manba}
                                                    onChange={e => setSteHandler(e.target.value, i, 'manba')}>
                                                <option value="">--tanlang--</option>
                                                {
                                                    manbalar.length ?
                                                        manbalar.map((m, i) => {
                                                            return <option value={m.id} key={i}>{m.name}</option>
                                                        })
                                                        : null
                                                }
                                            </select>
                                        </td>
                                        <td className="inptd">
                                            <input type="text" className="inputable" value={s.name}
                                                   onChange={e => setSteHandler(e.target.value, i, 'name')}/>
                                        </td>
                                        <td className="inptd">
                                            <select className="inputable" value={s.yonalish}
                                                    onChange={e => setSteHandler(e.target.value, i, 'yonalish')}>
                                                <option value="">--tanlang--</option>
                                                {
                                                    yonalishlar.length ?
                                                        yonalishlar.map((m, i) => {
                                                            return <option value={m.id} key={i}>{m.yonalish}</option>
                                                        })
                                                        : null
                                                }
                                            </select>
                                        </td>
                                        <td className="inptd"><input type="number"
                                                                     className="inputable text-center no-arrow"
                                                                     value={s.d1}
                                                                     onChange={e => setSteHandler(e.target.value, i, 'd1')}/>
                                        </td>
                                        <td className="inptd"><input type="number"
                                                                     className="inputable text-center no-arrow"
                                                                     value={s.d2}
                                                                     onChange={e => setSteHandler(e.target.value, i, 'd2')}/>
                                        </td>
                                        <td className="inptd"><input type="number"
                                                                     className="inputable text-center no-arrow"
                                                                     value={s.d3}
                                                                     onChange={e => setSteHandler(e.target.value, i, 'd3')}/>
                                        </td>
                                        <td className="inptd"><input type="number"
                                                                     className="inputable text-center no-arrow"
                                                                     value={s.d4}
                                                                     onChange={e => setSteHandler(e.target.value, i, 'd4')}/>
                                        </td>
                                        <td className="inptd"><input type="number"
                                                                     className="inputable text-center no-arrow"
                                                                     value={s.d5}
                                                                     onChange={e => setSteHandler(e.target.value, i, 'd5')}/>
                                        </td>
                                        <td className="inptd"><input type="number"
                                                                     className="inputable text-center no-arrow"
                                                                     value={s.d6}
                                                                     onChange={e => setSteHandler(e.target.value, i, 'd6')}/>
                                        </td>
                                        <td className="inptd"><input type="number"
                                                                     className="inputable text-center no-arrow"
                                                                     value={s.d7}
                                                                     onChange={e => setSteHandler(e.target.value, i, 'd7')}/>
                                        </td>
                                        <td className="inptd"><input type="number"
                                                                     className="inputable text-center no-arrow"
                                                                     value={s.d8}
                                                                     onChange={e => setSteHandler(e.target.value, i, 'd8')}/>
                                        </td>
                                        <td className="inptd"><input type="number"
                                                                     className="inputable text-center no-arrow"
                                                                     value={s.d9}
                                                                     onChange={e => setSteHandler(e.target.value, i, 'd9')}/>
                                        </td>
                                        <td className="inptd"><input type="number"
                                                                     className="inputable text-center no-arrow"
                                                                     value={s.d10}
                                                                     onChange={e => setSteHandler(e.target.value, i, 'd10')}/>
                                        </td>
                                        <td className="inptd"><input type="number"
                                                                     className="inputable text-center no-arrow"
                                                                     value={s.d11}
                                                                     onChange={e => setSteHandler(e.target.value, i, 'd11')}/>
                                        </td>
                                        <td className="inptd"><input type="number"
                                                                     className="inputable text-center no-arrow"
                                                                     value={s.d12}
                                                                     onChange={e => setSteHandler(e.target.value, i, 'd12')}/>
                                        </td>
                                        <td className="inptd"><input type="number"
                                                                     className="inputable text-center no-arrow"
                                                                     value={s.d13}
                                                                     onChange={e => setSteHandler(e.target.value, i, 'd13')}/>
                                        </td>
                                        <td className="inptd"><input type="number"
                                                                     className="inputable text-center no-arrow"
                                                                     value={s.d14}
                                                                     onChange={e => setSteHandler(e.target.value, i, 'd14')}/>
                                        </td>
                                        <td className="inptd"><input type="number"
                                                                     className="inputable text-center no-arrow"
                                                                     value={s.d15}
                                                                     onChange={e => setSteHandler(e.target.value, i, 'd15')}/>
                                        </td>
                                        <td className="inptd"><input type="number"
                                                                     className="inputable text-center no-arrow"
                                                                     value={s.d16}
                                                                     onChange={e => setSteHandler(e.target.value, i, 'd16')}/>
                                        </td>
                                        <td className="inptd"><input type="number"
                                                                     className="inputable text-center no-arrow"
                                                                     value={s.d17}
                                                                     onChange={e => setSteHandler(e.target.value, i, 'd17')}/>
                                        </td>
                                        <td className="inptd"><input type="number"
                                                                     className="inputable text-center no-arrow"
                                                                     value={s.d18}
                                                                     onChange={e => setSteHandler(e.target.value, i, 'd18')}/>
                                        </td>
                                        {
                                            s.yonalish == 5 ?
                                                <td className="inptd"><input type="number"
                                                                             className="inputable text-center no-arrow"
                                                                             value={s.q}
                                                                             onChange={e => setSteHandler(e.target.value, i, 'q')}/>
                                                </td>
                                                : null
                                        }
                                    </tr>
                                })
                                : null
                        }
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="col-12">
                <div className="d-flex justify-content-between">
                    <div className="d-flex">
                        <button onClick={() => addHandler()} className="btn btn-outline-primary d-flex align-items-center">Yangi
                            sanoat yaratish&nbsp;&nbsp;{<PlusOutlined/>}</button>
                        &nbsp;&nbsp;&nbsp;
                        <button disabled={!forDelete} onClick={() => deleteHandler()}
                                className="btn btn-outline-danger d-flex align-items-center">O'chirish&nbsp;&nbsp;{
                            <DeleteOutlined/>}</button>
                    </div>
                    <div className="d-flex">
                        <button disabled={saved} className="btn btn-outline-success d-flex align-items-center"
                                onClick={() => saveHandler()}>Saqlash&nbsp;&nbsp;{<SaveOutlined/>}</button>
                        &nbsp;&nbsp;&nbsp;
                    </div>
                </div>

            </div>
        </div>
    );
}

export default Ste;